import React from 'react';
import AutomaticDrawer from 'components/Drawers/AutomaticDrawer';
import { Button } from 'antd';
import { useConnectClickFunnelsMutation } from 'modules/apps/apps/ClickFunnelsApp/api/clickfunnels.api';
import ConnectedClickFunnels from '../tables/ConnectedClickFunnels';
import { snackbar } from 'components/notifications/notifications';

const ClickFunnelsDrawer = (props) => {
  const [useConnectClickFunnelsRequest, { isLoading }] = useConnectClickFunnelsMutation();

  const startConnectingClickFunnels = async () => {
    const snack = snackbar.loading('Waiting for Login...');

    return await useConnectClickFunnelsRequest()
      .unwrap()
      .then((data) => {
        const newWindow = window.open(
          data.redirect_url,
          'ClickFunnels Login',
          'width=800,height=600,left=200,top=200'
        );

        socketEvents.one('clickfunnels.connected', () => {
          newWindow.close();
        });

        socketEvents.one('clickfunnels.error', () => {
          newWindow.close();
          snack({
            hide: false,
            type: 'error',
            title: 'Error while connceting clickFunnels accounts',
            duration: 3,
          });
        });
      })
      .catch((err) => {
        newWindow.close();
        snack({
          hide: false,
          type: 'error',
          title: 'Error while connceting clickFunnels accounts',
          duration: 3,
        });
      });
  };

  return (
    <AutomaticDrawer size='large' title='ClickFunnels' {...props}>
      <div className='py-4'>
        <Button type='primary' onClick={startConnectingClickFunnels} isLoading={isLoading}>
          Connect New Store
        </Button>
      </div>

      <ConnectedClickFunnels />
    </AutomaticDrawer>
  );
};

ClickFunnelsDrawer.requiredParams = {
  app: (app) => 'clickfunnels' === app,
};

export default ClickFunnelsDrawer;
